<template>
    <div class="container mt-5">
        <h1>FAQ</h1>

        <h2>When can I contact the escort girls?</h2>
        <p>
            You can write text messages any time you wish. Maybe the ladies will not answer right away, but you will have an answer as soon as possible.
        </p>

        <h2>How long before the meeting shall I book?</h2>
        <p>
            It is all up to the escort girl you are looking for. She might be free to meet you right as you text, but she might not be able to see you until the next day.<br>
            The sooner you book, the better.
        </p>

        <h2>Where can I meet the girls?</h2>
        <p>
            Most advertisers offer to meet at their own place or they can visit your hotel / appartment / flat anywhere in Budapest. Let the chosen escort girl know where you’d like to meet and she will let you know if that is possible.
        </p>

        <h2>Can I text only in English?</h2>
        <p>
            Not at all. Use a language that you are comfortable with.
        </p>

        <h2>What if I want to speak to a lady instead of texting?</h2>
        <p>
            Ask her and she might be able to contact you via phone / Skype / Viber etc.
        </p>

        <h2>What if I want to meet more than 1 girl at the same time?</h2>
        <p>
            Then meet. Just make sure, to let them know that you are looking for 2 or more companions for yourself or your friends too, so they won’t get surprised. Who knows, maybe they can recommend you other girls that they know, will suit your wishes.
        </p>

        <h2>What is the rate for a meeting?</h2>
        <p>
            As budapestescort.eu is not involved with anything other than giving an advertisement surface for budapest escort girls, we cannot give you information about the prices or services. Please text the ladies and they will let you know anything that you ask.
        </p>

        <h2>What payment methods are accepted?</h2>
        <p>
            Cash. Escort girls accept EUR, HUF, USD, GBP.
        </p>

        <h2>Are the prices negotiable?</h2>
        <p>
            No, they are not.
        </p>

        <h2>Are the ladies available NON-STOP?</h2>
        <p>
            They might be able to answer you any time, when they notice your text, but they can only meet you during the night, between 18:00 – 03:00.
        </p>

        <h2>How long can a meeting last?</h2>
        <p>
            It is all up to you and the advertiser girl to discuss.
        </p>

        <h2>What if I want to cancel a meeting?</h2>
        <p>
            Write a text to your escort and let her know, that you’d like to cancel. She will understand. Just please make sure not to cancel it 10 minutes before the meeting.
        </p>

        <p>
            The webiste of {{ domain }} provides opportunities for models to appear on the internet. Models are working as individuals, they can give you information about their services. Budapest-escort-girl.eu cannot provide any further information about their services. What happens between a comapnion and a client is based on their choices,  {{ domain }} will not take responsibility for these actions.
        </p>
    </div>
</template>

<script>
    export default {
        name: "Faq",
        metaInfo: {
            title: 'FAQ'
        },
        data() {
            return {
                domain: process.env.VUE_APP_DOMAIN
            }
        }
    }
</script>

<style scoped>

</style>
